<template>
    <div style="height:100%;">
        <div class="success" v-if="dialogVisible">
            <div> <img src="../../../assets/img/success.png"> </div>
            <div> 机构增补成功，是否继续增补？ </div>
            <div>
                <el-button  @click="goHome">返回首页</el-button>
                <el-button type="primary" @click="goOn">继续增补</el-button>
            </div>
            <div class="desc">医疗机构增补智能评估系统</div>
        </div>
        <div class="page" v-else>
            <div class="title">请填写机构信息.</div>
            <el-form ref="formData" :model="formData" label-width="120px" size="mini">

                <el-form-item label="机构名称：">
                    <el-input v-model="formData.companyName" class="long"></el-input>
                </el-form-item>

                <el-form-item label="机构类别：">
                    <el-select v-model="formData.companyCategoryId" placeholder="请选择" class="short">
                        <el-option v-for="(item,index) in allCategoryArray" :key="index" :label="item.companyCategoryName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="机构级别：">
                    <el-select v-model="formData.companyLevel" placeholder="请选择" class="short">
                        <el-option v-for="(item,index) in companyLevelArray" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="经营性质：">
                    <el-select v-model="formData.businessNature" placeholder="请选择" class="short">
                        <el-option v-for="(item,index) in businessNatureArray" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="机构位置：">
                    <el-input v-model="formData.companyDetailAddress" :disabled="editAddress" class="long" @blur="sureAddress()"></el-input> <!-- <el-button class="openmap" type="primary" @click="showMap">选择地址</el-button> -->
                    <div class="tip">*请输入省市区以及详细地址，以便于机构定位</div>
                </el-form-item>
                <el-form-item label="机构经度：">
                    <el-input v-model="formData.longitude" class="short" @focus="showlonlatbtn = true" @input="formData.longitude=formData.longitude.replace(/[^\-\d.]/g, '')"></el-input>
                </el-form-item>
                <el-form-item label="机构纬度：">
                    <el-input v-model="formData.latitude" class="short" @focus="showlonlatbtn = true" @input="formData.latitude=formData.latitude.replace(/[^\-\d.]/g, '')"></el-input>
                </el-form-item>
                <el-form-item v-show="showlonlatbtn">
                    <el-button type="primary" class="submit" @click="lonlatSure">确定</el-button>
                </el-form-item>
                <div class="maptop"> <span>所在街道(镇)：{{town}}</span> <span>所属区域：{{area.length ? area.toString() : '无'}}</span> </div>
                <div id="baidu-map-container1" style="width:46vw" class="map"></div> <!-- :style="{'width':mapwidth+'px'}"  -->

                <el-form-item label="行政区划：">
                    <el-cascader placeholder="行政区划" :change-on-select="true" clearable filterable :props="defaultProps" v-model="zone" :options="zoneArray"  expand-trigger="hover" class="long"></el-cascader>
                </el-form-item>

                <el-form-item label="服务方式：">
                    <el-select v-model="serviceMethod" placeholder="请选择" multiple class="long">
                        <el-option v-for="(item,index) in serviceMethodArray" :key="index" :label="item.serviceMethodName" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="服务对象：">
                    <el-select v-model="formData.serviceObject" placeholder="请选择" class="short">
                        <el-option v-for="(item,index) in serviceObjectArray" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="诊疗科目：">
                    <!-- <el-select v-model="medicalSubjectId" placeholder="请选择" multiple class="long">
                        <el-option v-for="(item,index) in medicalSubjectIdArray" :key="index" :label="item.medicalSubjectName" :value="item.id"> </el-option>
                    </el-select> -->
                    <el-cascader placeholder="请选择" :change-on-select="true" clearable filterable :props="multProps" v-model="medicalSubjectId" :options="medicalSubjectIdArray"  expand-trigger="hover" class="long"></el-cascader>
                </el-form-item>

                <el-form-item label="床位数：">
                    <el-input v-model="formData.bedNum" class="short"></el-input><span class="unit">位</span>
                </el-form-item>

                <el-form-item label="牙椅数：">
                    <el-input v-model="formData.teethChairNum" class="short"></el-input><span class="unit">位</span>
                </el-form-item>

                <el-form-item label="联系电话：">
                    <el-input v-model="formData.phone" maxlength="11" class="short"></el-input>
                </el-form-item>

                <el-form-item label="备注：">
                    <el-input type="textarea" :rows="5" v-model="formData.remark" class="long"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" class="submit" @click="onSubmit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
        <mapAddressSelect ref="bmapAddressSelect" @confirmMapAddress="confirmMapAddress"></mapAddressSelect>
    </div>
</template>

<script>
import mapAddressSelect from "../../../components/mapAddressSelect";
        export default {
        components:{
            mapAddressSelect
        },
        data() {
            return {
                companyLevelArray:[
                    {name: '一级', id: 0},
                    {name: '二级', id: 1},
                    {name: '三级', id: 2},
                    {name: '无级别', id: 3},
                    {name: '未定级', id: 4},
                ],
                serviceObjectArray:[
                    {name: '内部', id: 0},
                    {name: '社会', id: 1},
                    {name: '社会+内部', id: 2},
                ],
                businessNatureArray:[
                    {name: '营利性', id: 0},
                    {name: '非营利性(政府办)', id: 1},
                    {name: '非营利性(非政府办)', id: 2},
                ],
                zoneArray:[],
                defaultProps: {
                    children: 's',
                    label: 'n',
                    value: 'v',
                    expandTrigger: 'hover'
                },
                multProps: {
                children: 's',
                label: 'n',
                value: 'v',
                multiple: true
              },
                allCategoryArray: [],
                serviceMethodArray: [],
                medicalSubjectIdArray: [],
                
                medicalSubjectId: null,
                serviceMethod: '',
                zone: '',

                formData:{
                    companyName: '',
                    regionId: null,
                    serviceObject: '',
                    companyCategoryId: '',
                    companyLevel: '',
                    companyDetailAddress: '',
                    businessNature: '',
                    bedNum: '',
                    teethChairNum: '',
                    medicalSubjectId: null,
                    serviceMethod: '',
                    phone: '',
                    remark: '',
                    longitude:'',
                    latitude:''
                },
                dialogVisible: false,
                addressInfo:{},
                editAddress: false,
                mapwidth: 500,
                areaOne:['运河商务区', '张家湾设计小镇', '郭县医药卫生产业园区', '健康服务产业园区'],
                areaTwo:['北苑街道', '中仓街道', '玉桥街道', '临河里街道', '梨园镇', '九棵树街道', '潞邑街道', '潞源街道', '通运街道'],
                areaThree:['杨庄街道', '永顺镇', '新华街道', '宋庄镇', '张家湾镇', '潞城镇', '漷县镇'],
                areaFour:['于家务回族自治区', '于家务回族乡', '永乐店镇', '西集镇', '台湖镇', '马驹桥镇', '宋庄镇'],
                town: '',
                area: [],
                showlonlatbtn: false
            }
        },
        created(){
            this.initZoneArray()
            this.getAllCategory()
            this.getAllServiceMethod()
            this.getAllMedicalSubject()
        },
        mounted(){
            this.mapwidth = this.viewportToPixels('100vw')-850
            console.log(this.mapwidth)
            if(this.$route.query.addressInfo){
                this.editAddress = true
                this.addressInfo = this.$route.query.addressInfo
                this.formData.companyDetailAddress = this.addressInfo.address
                this.formData.longitude = this.addressInfo.longitude
                this.formData.latitude = this.addressInfo.latitude
                this.initBaiduMap(this.formData.latitude,this.formData.longitude)
            }else{
                this.initBaiduMap()
            }
        },
        methods:{
            viewportToPixels(value) {
                var parts = value.match(/([0-9.]+)(vh|vw)/)
                var q = Number(parts[1])
                var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
                return side * (q/100)
            },
            //获取行政区划
            initZoneArray(){
                const url = '/api/siteselection/zone/getAllRegionByCityId'
                this.axios.post(url,{cityId: this.$store.state.userInfo.user.region}).then( res =>{
                    this.zoneArray = res.data;
                });
            },
            //机构类别(经济类型)
            getAllCategory(){
                const url = '/api/siteselection/companyCategory/getAllCategory';
                this.axios.post(url,{}).then( res =>{
                    this.allCategoryArray = res.data.model;
                });
            },
            //服务方式
            getAllServiceMethod(){
                const url = '/api/siteselection/serviceMethod/getAllServiceMethod';
                this.axios.post(url,{}).then( res =>{
                    this.serviceMethodArray = res.data.model;
                });
            },
            //诊疗科目
            getAllMedicalSubject(){
                const url = '/api/siteselection/medicalSubject/getAllMedicalSubject';
                this.axios.post(url,{}).then( res =>{
                    this.medicalSubjectIdArray = res.data;
                });
            },
            showMap() {
                this.$refs.bmapAddressSelect.show();
            },
            confirmMapAddress(addressInfo) {
                this.addressInfo = addressInfo;
                this.formData.companyDetailAddress = addressInfo.address
                this.formData.longitude = addressInfo.longitude
                this.formData.latitude = addressInfo.latitude
                console.log('submit::',this.addressInfo);
            },
            lonlatSure(){
                if(this.formData.longitude && this.formData.latitude){
                    this.sureAddress(this.formData.latitude,this.formData.longitude)
                    this.showlonlatbtn = false
                }else{
                    this.$message({
                        message: "请输入合法的经纬度",
                        type: 'error'
                    });
                }
            },
            //反查经纬度
            sureAddress(lat,lng){
                if(lat,lng){
                    this.getTown(lat,lng)
                    this.map.clearOverlays(); 
                    let point = new BMap.Point(lng,lat);
                    this.map.centerAndZoom(point, 25);
                    var marker = new BMap.Marker(point); // 创建标注
                    this.map.addOverlay(marker); 
                }else if(this.formData.companyDetailAddress){
                    this.$jsonp('https://api.map.baidu.com/geocoding/v3/?address='+ this.formData.companyDetailAddress +'&output=json&ak=RpKLEzqP3GKfAL5yqi7cicc89xzhEe4r')
                    .then(res => {
                        console.log('sureAddress::',res.result.location);
                        const location = res.result.location;
                        if (location) {
                            this.formData.longitude = location.lng
                            this.formData.latitude = location.lat
                            this.zone = []
                            this.getTown(location.lat,location.lng)
                            this.map.clearOverlays(); 
                            let point = new BMap.Point(this.formData.longitude,this.formData.latitude);
                            this.map.centerAndZoom(point, 25);
                            var marker = new BMap.Marker(point); // 创建标注
                            this.map.addOverlay(marker); 
                        }
                    })
                }
            },
            getTown(lat,lng){
                this.area = []
                this.$jsonp(' https://api.map.baidu.com/reverse_geocoding/v3/?ak=RpKLEzqP3GKfAL5yqi7cicc89xzhEe4r&output=json&extensions_town=true&location='+ lat +','+ lng)
                .then(res => {
                    let data = res.result.addressComponent
                    let allzone = []
                    if(this.$store.state.userInfo.user.regionArr.filter(ele=> ele).length==3){
                        allzone.push(parseInt(data.town_code))
                    }else{
                        allzone.push(parseInt(data.adcode),parseInt(data.town_code))
                    }
                    this.zone = allzone
                    this.town = data.town
                    if(this.areaOne.includes(this.town)){ this.area.push('一类区域') }
                    if(this.areaTwo.includes(this.town)){ this.area.push('二类区域') }
                    if(this.areaThree.includes(this.town)){ this.area.push('三类区域') }
                    if(this.areaFour.includes(this.town)){ this.area.push('四类区域') }
                })
            },
            initBaiduMap(lat,lng) {
                let that = this;
                this.$nextTick(function () {
                    /** 初始化地图Start */
                    that.map = new BMap.Map("baidu-map-container1"); // 创建地图实例
                    let point = new BMap.Point(116.404, 39.915); // 设置中心点坐标
                    that.map.centerAndZoom(point, 25); // 地图初始化，同时设置地图展示级别
                    that.map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
                    /** 初始化地图End */
                    
                    if(lat,lng){
                        that.sureAddress(lat,lng)
                    }

                    /** 点击地图创建坐标事件Start */
                    // 添加地图点击事件
                    that.map.addEventListener("click", function (e) {
                        var clickpt = e.point; // 点击的坐标
                        that.map.clearOverlays(); // 移除地图上的标注
                        var marker = new BMap.Marker(clickpt); // 创建标注
                        that.map.addOverlay(marker); // 将标注添加到地图中
                        console.log('clickpt',clickpt)
                        that.formData.longitude = clickpt.lng
                        that.formData.latitude = clickpt.lat
                        that.zone = []
                        that.getTown(clickpt.lat,clickpt.lng)
                    });
                    /** 点击地图创建坐标事件End */
                });
            },
             onSubmit() {
                console.log('this.zone::',this.zone);
                const Length = this.zone ? this.zone.length : 0;
                this.formData.regionId = Length > 0 ? this.zone[Length-1] : null;
                // this.formData.medicalSubjectId = this.medicalSubjectId
                this.formData.serviceMethod = this.serviceMethod.join(",")
                console.log('submit::',this.formData);

                const url = '/api/siteselection/company/addOrUpdateCompany';
                let params = {
                    regionId: this.formData.regionId,
                    medicalSubjects: this.medicalSubjectId,
                    company: this.formData
                }
                this.axios.post(url,params,{transformRequest: function (params) {return JSON.stringify(params);},
                    headers: {'Content-Type': 'application/json;charset=UTF-8'}
                }).then( res =>{
                    if(res.data.code=='00000'){
                        this.dialogVisible = true
                    }else{
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                });
                
            },
            goHome(){
                this.$router.push("/index/list");
            },
            goOn(){
                this.medicalSubjectId = null
                this.serviceMethod = ''
                this.zone = ''
                this.editAddress = false
                this.formData ={
                    companyName: '',
                    regionId: null,
                    serviceObject: '',
                    companyCategoryId: '',
                    companyLevel: '',
                    companyDetailAddress: '',
                    businessNature: '',
                    bedNum: '',
                    teethChairNum: '',
                    medicalSubjectId: null,
                    serviceMethod: '',
                    phone: '',
                    remark: '',
                    longitude:'',
                    latitude:''
                }
                this.dialogVisible = false
                this.initBaiduMap()
            }
        }
    }
</script>

<style lang="less" scoped>
.page{
    width: 100%;
    min-height: calc(100vh - 100px);
    background: white;
    box-sizing: border-box;
    padding: 20px 28px;
    .title{
        font-size: 16px;
        font-weight: bold;
        color: #333333;
    }
    .el-form{
        margin-top: 20px;
    }
}
/deep/ .el-input{
    width: auto;
}
/deep/.el-input--mini .el-input__inner{ height: 36px; line-height: 36px; font-size: 15px; color: #000000;}
/deep/.el-form-item--mini .el-form-item__label{ line-height: 36px!important; font-size: 16px; color: #000000;}
/deep/.long .el-input__inner{
    width: 400px;
}
/deep/.short .el-input__inner{
    width: 220px;
}
/deep/.long .el-textarea__inner{
    width: 400px;
}
/deep/.el-form-item__content{
    // display: flex;
    position: relative;
}
.unit{
    position: absolute;
    top: 1px;
    left: 196px;
    color: #777;
}
.openmap{
    position: absolute;
    top: 1px;
    left: 415px;
    height: 36px;
    line-height: 36px;
    padding: 0 15px;
    font-size: 16px;
}
.submit{
    width: 218px;
    height: 36px;
    line-height: 36px;
    padding: 0;
    font-size: 17px;
}
.success{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: white;
    text-align: center;
    font-size: 24px;;
    color: #000000;
    img{
        width: 40px;
        margin: 88px 0 40px;
    }
    .el-button{
        width: 160px;
        height: 36px;
        line-height: 36px;
        padding: 0;
        margin: 86px 40px;
    }
    .desc{
        position: absolute;
        left: 50%;
        bottom: 40px;
        font-size: 16px;
        font-weight: bold;
        color: #E6E6E6;
    }
}
    .tip{
        color: red;
        font-size: 12px;
        line-height: 36px;
    }
    .map{
        height: 400px;
        position: absolute;
        top: 200px;
        right: 10px;
    }
    .maptop{
        position: absolute;
        top: 160px;
        left: 54vw;
        span{
            margin-right: 20px;
        }
    }
</style>
